import { InventoryAuthority } from '@qkindex/contracts';
import type { InventoryResource } from './collectionInventoryStore';
import type { Item } from '../../domain/item';
import type { Location } from '../../domain/location';

export type InventoryChange = Pick<
  InventoryAuthority,
  'userId' | 'collectionId'
> & {
  resources?: InventoryResource[];
  deletedLocationIds?: string[];
  deletedItemIds?: string[];
  upsertItems?: Item[];
  upsertLocations?: Location[];
  /** Fetch authoritative records when the write result contains only identities. */
  reloadItemIds?: string[];
  reloadLocationIds?: string[];
};
const listeners = new Set<(change: InventoryChange) => void>();

/** Successful mutations notify only readers for the same user and collection. */
export function invalidateInventory(change: InventoryChange) {
  listeners.forEach((listener) => listener(change));
}

export function subscribeInventoryInvalidations(
  listener: (change: InventoryChange) => void,
) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function subscribeInventoryChanges(
  userId: string,
  onChange: (collectionId: string, deletedLocationIds?: string[]) => void,
) {
  const listener = (change: InventoryChange) => {
    if (change.userId !== userId) return;
    if (change.deletedLocationIds)
      onChange(change.collectionId, change.deletedLocationIds);
    else onChange(change.collectionId);
  };
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
